import { FC } from 'react'
import {
    Outlet
} from "react-router-dom";


const AnalyticPage: FC = () => {  
    return (
        <Outlet />
    );
}

export default AnalyticPage